/* eslint-disable multiline-ternary */
import { Component } from 'preact'
import { isChangeEvent } from '../../libs/typeGuards'
import Icon from '../assets'

interface Props {
  title: string
  onTitleChanged: CallableFunction
  placeholder?: string
}

interface State {
  showTitleInput: boolean
}

class TitleInput extends Component<Props, State> {
  titleInputRef: HTMLElement | null = null

  constructor(props: Props) {
    super(props)
    this.state = {
      showTitleInput: false
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', (e: MouseEvent) => this.onClickOutsideOfTitle(e))
    document.addEventListener('keypress', (e: KeyboardEvent) => this.onPressEnterInTitle(e))
  }

  onTitleClicked() {
    this.setState({ showTitleInput: true }, () => {
      if (this.titleInputRef) {
        this.titleInputRef.focus()
      }
    })
  }

  onClickOutsideOfTitle(e: MouseEvent) {
    if (this.titleInputRef && !this.titleInputRef.contains(e.target as Node)) {
      this.titleInputRef.blur()
      this.setState({ showTitleInput: false })
    }
  }

  onPressEnterInTitle(e: KeyboardEvent) {
    if (this.titleInputRef && e.keyCode === 13) {
      this.titleInputRef.blur()
      this.setState({ showTitleInput: false })
    }
  }

  render() {
    const { title, onTitleChanged, placeholder } = this.props
    if (this.state.showTitleInput) {
      return (
        <div className='title-input'>
          <input
            className='qa-title-input form-control'
            type='text'
            value={title}
            required
            onChange={(e) => {
              if (isChangeEvent(e)) {
                onTitleChanged(e.target.value.trim())
              }
            }}
            maxLength={250}
            ref={(titleInput) => {
              this.titleInputRef = titleInput
            }}
          />
        </div>
      )
    }
    return (
      <div className='title-input'>
        <div className='title-input__title' onClick={() => this.onTitleClicked()}>
          <h2 className='control-header__title qa-title-text'>
            {placeholder && title.length === 0 ? (
              <span className='title-input__title--placeholder'>{placeholder}</span>
            ) : (
              title
            )}
            <Icon icon='edit' width={20} height={20} />
          </h2>
        </div>
      </div>
    )
  }
}

export default TitleInput
